import axios from '@axios';

export default {
  async fetchChangeLog(query?: object) {
    return await axios.get('/changelog', { params: query });
  },

  async fetchChangeLogById(id: number, query?: object) {
    return await axios.get(`/changelog/${id}`, { params: query });
  },

  async fetchChangeLogWhatsNew(query?: object) {
    return await axios.get('/whats-new', { params: query });
  }
};
